(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["norvio-guarantee"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-nv-scroll-top]');
    if (!trigger) return;
    event.preventDefault();

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["norvio-painpoints"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initPainpoints(root) {
      var scroller = root.querySelector('.pp__grid');
      var dots = root.querySelectorAll('.pp__dot');
      if (!scroller || dots.length === 0) return;

      function paint() {
        var isSwipe = root.classList.contains('pp--mobile-swipe');
        if (!isSwipe || window.innerWidth > 720 || scroller.clientWidth === 0) return;
        var max = dots.length - 1;
        var idx = Math.round(scroller.scrollLeft / (scroller.scrollWidth / dots.length));
        if (idx < 0) idx = 0;
        if (idx > max) idx = max;
        for (var i = 0; i < dots.length; i++) {
          dots[i].classList.toggle('pp__dot--active', i === idx);
        }
      }

      var timer;
      scroller.addEventListener('scroll', function () {
        clearTimeout(timer);
        timer = setTimeout(paint, 60);
      }, { passive: true });
      window.addEventListener('resize', paint);
      paint();
    }

    function boot() {
      var roots = document.querySelectorAll('[data-painpoints]');
      for (var i = 0; i < roots.length; i++) initPainpoints(roots[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('[data-painpoints]');
      if (root) initPainpoints(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["norvio-trust-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('.shopify-section--norvio-trust');
    sections.forEach(function (section) {
      var scroller = section.querySelector('.norvio-trust__scroller');
      if (!scroller) return;
      var dots = section.querySelectorAll('.norvio-trust__dot');
      if (dots.length === 0) return;
      var items = scroller.querySelectorAll('.norvio-trust__item');
      if (items.length === 0) return;

      function updateDots() {
        if (window.innerWidth > 720) return;
        var scrollLeft = scroller.scrollLeft;
        var itemWidth = scroller.clientWidth;
        var activeIndex = Math.round(scrollLeft / itemWidth);
        dots.forEach(function (dot, i) {
          dot.style.background = i === activeIndex ? '#F978A6' : '#E8DFD6';
        });
      }

      var scrollTimeout;
      scroller.addEventListener('scroll', function () {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(updateDots, 50);
      });

      window.addEventListener('resize', updateDots);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
